import { EDIT_ACTION, VIEW_ACTION } from "constants/actions";
import { TESDA_PROGRAM_STEP_ID } from "constants/agency";

export const getHeaderText = (action) => {
  let headerText = "Course Details";

  if (action === EDIT_ACTION) {
    return "Edit Course";
  }

  if (action !== VIEW_ACTION) {
    headerText = "Add New Course";
  }

  return headerText;
};

export const validateTVICourseForm = ({
  form,
}) => {

  if (
    form.projectId?.value === TESDA_PROGRAM_STEP_ID &&
    (form.toolKitCost === 0 || form.toolKitCost === null)
  ) {
    return "Tool Kit Cost cannot be empty or zero";
  }

  return true;
};
